<template>
    <dashboard-layout title="회사정보 관리" topBtn>
        <template slot="topBtn">
            <v-fade-transition hide-on-leave>
                <v-btn v-show="mode == 'view'" color="primary" v-bind="{ loading }" @click="mode = 'form'"> 수정하기 </v-btn>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-btn v-show="mode == 'form'" color="secondary" v-bind="{ loading }" @click="mode = 'view'"> 취소하기 </v-btn>
            </v-fade-transition>
        </template>
        <template slot="contents">
            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">개인정보</h5>
            <company-baseinfo-form v-model="form" v-bind="{ mode }" class="mb-40 mb-lg-60" />

            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">상세정보</h5>
            <company-moreinfo-form v-model="form" v-bind="{ mode }" class="mb-40 mb-lg-60" />

            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">소개정보</h5>
            <company-metainfo-form v-model="form" v-bind="{ mode }" />

            <v-slide-y-reverse-transition>
                <div v-show="mode == 'form'">
                    <v-card-actions>
                        <div class="v-btn-group">
                            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="reset">
                                <span class="grey-6--text">초기화</span>
                            </v-btn>
                            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                                <span>저장하기</span>
                            </v-btn>
                        </div>
                    </v-card-actions>
                </div>
            </v-slide-y-reverse-transition>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { getGeolocation } from "@/plugins/getGeolocation";
import { USER_FILE_TYPES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import CompanyBaseinfoForm from "@/components/dashboard/company/company/company-baseinfo-form.vue";
import CompanyMoreinfoForm from "@/components/dashboard/company/company/company-moreinfo-form.vue";
import CompanyMetainfoForm from "@/components/dashboard/company/company/company-metainfo-form.vue";

export default {
    components: {
        DashboardLayout,
        CompanyBaseinfoForm,
        CompanyMoreinfoForm,
        CompanyMetainfoForm,
    },
    data: () => ({
        user: undefined,
        form: undefined,

        mode: "view",
        loading: false,
    }),
    computed: {
        profileSrc() {
            if (this.user?.profile?.url) return this.user.profile.url;
            if (this.user?.profile instanceof File) return URL.createObjectURL(this.user.profile);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        mode(mode) {
            if (mode == "view") this.reset();
        },
    },
    methods: {
        init() {
            this.loading = false;
            this.user = undefined;
            this.search();
        },
        reset() {
            this.form = JSON.parse(JSON.stringify(this.user));
        },
        async search() {
            this.loading = true;
            try {
                var { user } = await api.v1.me.get();
                this.user = user;
            } finally {
                this.reset();
                this.loading = false;
            }
        },
        async save() {
            this.loading = true;
            try {
                let { logo, businessRegistration, introduction, ...form } = this.form || {};

                form.geolocation = await getGeolocation(form.address1);

                // 로고
                if (logo instanceof File) {
                    logo = (await api.v1.me.files.post({ type: USER_FILE_TYPES.LOGO.value }, logo))?.file;
                }
                form._logo = logo?._id;

                // 사업자등록증
                if (businessRegistration instanceof File) {
                    businessRegistration = (await api.v1.me.files.post({ type: USER_FILE_TYPES.BUSINESS_REGISTRATION.value }, businessRegistration))?.file;
                }
                form._businessRegistration = businessRegistration?._id;

                // 소개이미지
                for (let [index, item] of (introduction?.images || []).entries()) {
                    if (item instanceof File) {
                        introduction.images[index] = (await api.v1.me.files.post({ index: `introduction-image-${index}` }, item))?.file;
                    }
                }
                const _introductionImages__toDelete = (introduction._images || []).filter((_image) => !introduction?.images?.some(({ _id }) => _id == _image));
                for (const _id of _introductionImages__toDelete) {
                    await api.v1.me.files.delete({ _id });
                }
                form.introduction = {
                    _images: (introduction?.images || []).map(({ _id }) => _id),
                    content: introduction?.content,
                };

                var { user } = await api.v1.me.put(form);
                this.user = user;
            } finally {
                this.loading = false;
                this.mode = "view";
            }
        },
    },
};
</script>

<style></style>
